export function userLoggedUsecaseFactory(deps) {
    return deps.authRepository.doAuth0Callback;
}
//# sourceMappingURL=user-logged.usecase.js.map